import RelatoriosManager from "./components/RelatoriosManager";

const Relatorios = () => {
  return <RelatoriosManager />;
};

export default Relatorios;
